const BASE_URL = "https://api.runwearshoes.pk";
//const BASE_URL = "http://localhost:4003";

export default BASE_URL;